export function createAction(actionName, creator = (type, value) => ({type, value})) {
  return [actionName, creator.bind(null, actionName)];
}

export function switchExpression(target, options) {
  return Object.prototype.hasOwnProperty.call(options, target) ? options[target] : null;

}
